var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pulse-statistics"},[_c('data-abstract-unit',{attrs:{"title":"平均脉率","value":_vm.model.averagePulse}}),_c('data-abstract-unit',{attrs:{"title":"最大脉率","value":_vm.model.maxPulse}}),_c('data-abstract-unit',{attrs:{"title":"最小脉率","value":_vm.model.minPulse}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }